import { redirect } from "@tanstack/react-router";
import { resolveVerificationLegacyRedirect } from "./verification-legacy-redirects";

type AgentsUnmountLocation = {
  pathname: string;
  searchStr?: string;
};

/** Keep child beforeLoad redirects identical to the root's object-aware hop. */
export function hopLeftoverAgentsToDashboard(location: AgentsUnmountLocation): never {
  const destination =
    resolveVerificationLegacyRedirect(location.pathname, location.searchStr ?? "") ?? "/";
  throw redirect({
    to: destination,
    replace: true,
  });
}

/** Redirect when the location is legacy; leave retained canonical pages alone. */
export function hopLeftoverLegacyRoute(location: AgentsUnmountLocation): void {
  const destination = resolveVerificationLegacyRedirect(
    location.pathname,
    location.searchStr ?? "",
  );
  if (destination) throw redirect({ to: destination, replace: true });
}
